import { extractReleaseVersion } from '@/api/helpers'
import { router } from '@/router'
import * as Sentry from '@sentry/vue'
import type { Plugin } from 'vue'

export const SentryPlugin: Plugin = {
  install: (app) => {
    if (import.meta.env.DEV) return

    Sentry.init({
      app,
      environment: import.meta.env.MODE,
      dsn: import.meta.env.VITE_APP_SENTRY_DSN,
      release: extractReleaseVersion(import.meta.env.VITE_APP_RELEASE_VERSION),
      integrations: [
        Sentry.browserTracingIntegration({ router })
      ],
      tracesSampleRate: import.meta.env.MODE === 'prod' ? 0.3 : 0,
      normalizeDepth: 10,

      ignoreErrors: [
        'Error: Network Error',
        'ResizeObserver loop limit exceeded'
      ],

      // options for tracking performance
      beforeBreadcrumb (breadcrumb: any, hint: any) {
        if (breadcrumb.category === 'xhr' && ['POST', 'PATCH'].includes(breadcrumb.data?.method) && breadcrumb.data?.status_code !== 200) {
          // fields, that we have to hide in sentry
          const sensitiveFields = ['password', 'token', 'address']

          const mappedRequestPayload = Object.fromEntries(Object.entries(JSON.parse(hint.input)).map(e => {
            if (sensitiveFields.includes(e[0])) e[1] = '***********'
            return e
          }))

          breadcrumb.data.requestPayload = JSON.stringify(mappedRequestPayload) || 'SentryIssue'
          breadcrumb.data.responseData = hint.xhr?.responseText || ''
        }
        return breadcrumb
      }
    })
  }
}

export const setSentryUser = (user: IUser) => {
  const sentryUser = { ...user, id: user.subId }

  const isImpersonate = !!cookieService.getCookie('impersonateToken')

  Sentry.setUser(sentryUser)
  Sentry.setTag('isImpersonate', isImpersonate)
  isImpersonate && Sentry.setTag('impersonatedUserEmail', user.impersonatedUserEmail)
}
